import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls the window to the top
 * whenever the route changes. This only affects page-level navigation,
 * not modal or popup interactions.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  // Disable browser's automatic scroll restoration once on mount
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // Scroll to top whenever the route changes
  useEffect(() => {
    // Use requestAnimationFrame to ensure DOM has updated, then scroll
    requestAnimationFrame(() => {
      // Small delay to ensure page content has rendered
      setTimeout(() => {
        // Scroll window to top with instant behavior (not smooth)
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'auto' // Use 'auto' instead of 'smooth' for instant scroll
        });
        
        // Also scroll document elements to ensure compatibility across browsers
        if (document.documentElement) {
          document.documentElement.scrollTop = 0;
          document.documentElement.scrollLeft = 0;
        }
        if (document.body) {
          document.body.scrollTop = 0;
          document.body.scrollLeft = 0;
        }
      }, 0);
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;

